import { useState } from "react";
import { ODOCreateRequest, ODOCreateResponse } from "../../types/cs";
import { apiClient } from "../../utils/api";

interface UseODOCreateReturn {
  isLoading: boolean;
  error: string;
  createODO: (data: ODOCreateRequest) => Promise<boolean>;
  clearError: () => void;
}

const useODOCreate = (): UseODOCreateReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const createODO = async (data: ODOCreateRequest): Promise<boolean> => {
    setIsLoading(true);
    setError("");

    try {
      const response = await apiClient.post<ODOCreateResponse>(
        "/api/v1/cs/odo/create",
        data
      );
      const { status } = response.data;

      if (status) {
        return true;
      } else {
        throw new Error("1:1 문의 생성 실패");
      }
    } catch (error) {
      console.error("문의 생성 오류:", error);
      setError("네트워크 오류가 발생했습니다. 다시 시도해주세요.");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const clearError = () => {
    setError("");
  };

  return {
    isLoading,
    error,
    createODO,
    clearError,
  };
};

export default useODOCreate;
